module.exports = __webpack_public_path__ + "static/media/time-black.4eeabac8.svg";